import { useEffect, useState } from "react";

import useSyndication from "../../hooks/useSyndication";

import AutoComplete from "../elements/AutoComplete";

const SyndicationSelect = ({ value, onChange }) => {
  const { syndicationList } = useSyndication();

  const [options, setOptions] = useState(null);

  useEffect(() => {
    getData();
  }, [syndicationList]);

  const getData = async () => {
    if (!syndicationList) return;

    const options = [];

    for (const syndication of syndicationList) {
      options.push({
        key: syndication.id,
        id: syndication.id,
        name: syndication.name,
      });
    }

    setOptions(options);
  };

  const handleChange = (newValue) => {
    onChange(newValue);
  };

  if (!options) return null;

  return (
    <AutoComplete
      id={"syndication"}
      label={"syndication"}
      value={value || ""}
      onChange={(newValue) => handleChange(newValue)}
      items={options}
    />
  );
};

export default SyndicationSelect;
